import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=297e8a5c&scoped=true"
import script from "./AboutHero.vue?vue&type=script&lang=js"
export * from "./AboutHero.vue?vue&type=script&lang=js"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=297e8a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e8a5c",
  null
  
)

export default component.exports